import { BaseReportView } from '@app/modules/audit/screens/global-reports/common/BaseReportView';
import { SectionHeader } from '@app/modules/social-export/screens/manage/platforms/FormSection';
import { auditReports } from '@mi-front/api-clients';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { GipReportInfo } from '../../config/info/GipReportInfo';

interface GipReportViewSharedProps {
  report: auditReports.GipReportDto | auditReports.GipAltReportDto;
  actions: React.ReactNode;
  exportInfo?: React.ReactNode;
}

/**
 * Shared presentational component for GIP and GIP Alternative reports.
 *
 * This component handles the common layout and structure for both report types,
 * while allowing each report type to provide its own export info implementation
 * through the exportInfo prop. This separation allows for different API patterns
 * while maintaining consistent UI structure.
 *
 * @param report - The report data (GipReport or GipAlternativeReport)
 * @param actions - The actions component (typically GipReportActions)
 * @param exportInfo - Optional export info component specific to the report type
 * @param showExport - Whether to show the export section (defaults to true)
 */
export function GipDetails({ report, actions, exportInfo }: GipReportViewSharedProps) {
  return (
    <BaseReportView report={report as any} actions={actions}>
      <Box mt={2}>
        <SectionHeader
          title={
            <FormattedMessage
              id="audit.gipReport.configTitle"
              defaultMessage="Configuración de reporte"
            />
          }
        />
        <GipReportInfo config={report.data.config} />
      </Box>
      {exportInfo && (
        <Box mt={2}>
          <SectionHeader
            title={
              <FormattedMessage
                id="audit.reportsView.export"
                defaultMessage="Export de evidencia"
              />
            }
          />
          {exportInfo}
        </Box>
      )}
    </BaseReportView>
  );
}
